<!-- 加购成功弹层 -->
<template>
  <v-os-popup
    :show="isShow"
    ref="shopCartPopup"
    title="加入购物车成功"
    @close="$emit('close')"
    class="vPopup"
    container="body"
    :height="isLowAndroid ? '80vh' : 'auto'"
  >
    <div class="sku-extra-product">
      <div class="header" tabindex="0">
        <template v-if="!hasAdditionRecommendList">
          <div class="title">超值加购</div>
          <div class="line"></div>
          <div class="sub-title" :class="subDesc ? 'sub-red' : ''" v-text="subDesc ? subDesc : '精选好物随心配'"></div>
        </template>
        <span v-else class="title">您可能还喜欢</span>
      </div>
      <div class="content">
        <component
          :is="hasAdditionRecommendList ? 'RecommendItem' : 'ProductItem'"
          v-for="item in commodityList"
          showCartbtn
          forbidJump
          :invert="false"
          :disabledCartbtnIds="disabledCartbtnIds"
          :showChecked="false"
          :additionSkuList="additionSkuList"
          :additionSpuList="additionSpuList"
          :key="item.spuId"
          :productItem="item"
          :trackSource="trackSource"
          @selectSku="selectSku"
          @addToCart="addToCart"
          v-track="hasAdditionRecommendList ?{
            act: 'show',
            params: {
              event_id: '081|085|02|077',
              algoInfo: item.algoInfo,
              recommand_id: item.id,
              request_id: item.reqId,
              score: item.score,
              sku_id: skuId
            }
          }:{}"
        ></component>
      </div>
    </div>
    <template v-slot:footer>
      <div class="footer">
        <v-button faceColor="#FEE6E7" textColor="#F10313" position="center" @click="stay">继续逛</v-button>
        <v-button position="center" @click="toShopingcart">去购物车结算</v-button>
      </div>
    </template>
  </v-os-popup>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { modifyCommodityApi, addCommodityApi } from '@/views/shopcart/list/api'
import ProductItem from '../product-item'
import RecommendItem from './Item.vue'
import env from '@/utils/clientEnv'
import axios from 'axios'
import { app } from '@/utils'
import config from '@/config'
import { formatNumber } from 'utils/common'

export default {
  name: 'ShopcartPopup',
  components: { ProductItem, RecommendItem },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLowAndroid: env.isLowAndroid,
      // 标记哪些sku在当前弹层已加购，已加购的在商品行中置灰
      disabledCartbtnIds: [],
      additionCartAddList: [],
      // 已选中的推荐商品
      selectRecommendSkus: [],
      addList: [],
      // 用于加购动画gif处理
      animGifUrl: 'https://zhanstatic.vivo.com.cn/wukong-zhan/img/386603cf-fbd0-45cb-9426-fe8e821c5f3b.gif', // 原gif地址
      cachedAnimationBlob: '', // 存储的blob转本地缓存 - gif本地缓存可重复执行
      uniqueAnimationSrc: '' // blob转src，展示用的gif地址， 使用后销毁避免内存泄漏
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler(val) {
        if (val) {
          this.addList = [] // 清空同个商详页的上次弹层的勾选
          // 加价购弹层展开，有多个规格的，需要默认选中 sku，推荐商品没有规格
          if (!this.hasAdditionRecommendList) {
            const t = []
            this.additionCommodityInfo.forEach(spu => {
              const sku = spu?.additionSkus[0]
              if (spu.additionSkus?.length > 0 && sku) {
                // 加价购数据需要处理属性
                sku.savePrice = parseFloat((sku.salePrice - sku.activityPrice).toFixed(2))
                sku.spuId = spu.spuId
                sku.spuName = spu.spuName
              }
              spu.additionSkus?.length > 1 && t.push(sku)
            })
            t.length > 0 && this.addAdditionCommodity(t)
          }
          this.$track({
            event_id: '081|084|02|077',
            popup_type: this.hasAdditionRecommendList ? 2 : 1, // 1:加价购;2:算法推荐
            sku_id: this.skuId
          })
        } else {
          this.$store.dispatch('detailv3/addAdditionCommodity', this.additionCartAddList)
          setTimeout(() => {
            this.additionCartAddList = []
            this.disabledCartbtnIds = []
          }, 150)
        }
        val ? this.addCartAniDom() : this.removeCartAniDom()
      }
    }
  },
  computed: {
    ...mapState('detailv3', [
      'additionCommodityInfo',
      'selectParams',
      'showAdditCommInfo',
      'additionRecommendList',
      'cartIdValue',
      'addCartParams'
    ]),
    ...mapGetters('detailv3', ['skuId', 'hasAdditionRecommendList']),
    // 加购活动商品、推荐商品
    commodityList() {
      return this.hasAdditionRecommendList ? this.additionRecommendList : this.additionCommodityInfo
    },
    trackSource() {
      if (this.source == 1) {
        return 1
      } else if (this.source == 2) {
        return 4
      } else if (this.source == 3) {
        return 2
      } else if (this.source == 9) {
        return 3
      } else {
        return 5
      }
    },
    // 已选加购商品信息
    additionCommodity() {
      return this.selectParams.additionCommodity
    },
    // 已选加购商品的sku信息
    additionSkuList() {
      if (!this.hasAdditionRecommendList) {
        return this.additionCommodity.map(el => el.skuId)
      }
    },
    // 已选购商品的spuid
    additionSpuList() {
      const list = []
      this.additionCommodity.forEach(el => {
        list.push(el.spuId)
      })
      return list
    },
    subDesc() {
      let money = 0
      if (this.additionSkuList.length) {
        // 如果有选中的加购商品，则计算节省多少钱
        this.additionCommodity.forEach(el => {
          money = money + el.savePrice
        })
        // 如果有节省，则返回节省多少钱
        if (money) {
          return `共省${formatNumber(money)}元`
        }
      }
      // 如果没节省，则计算目前显示的所有加购商品最多可以省多少钱
      if (!money) {
        this.showAdditCommInfo.forEach(el => {
          money = money + el.savePrice
        })
      }
      if (money) {
        return `最多可省${formatNumber(money)}元`
      } else {
        // 如果没有节省，则返回空字符串，显示默认文案
        return ''
      }
    }
  },
  //方法集合
  methods: {
    ...mapActions('detailv3', [
      'addAdditionCommodity',
      'removeAdditionCommodity',
      'updateShowAdditCommInfo',
      'fetchCartNumber'
    ]),
    selectSku(skuItem) {
      // 取消选中
      if (this.additionSkuList.includes(skuItem.skuId)) {
        this.removeAdditionCommodity(skuItem)
      } else {
        // 选中
        this.addAdditionCommodity(skuItem)
        this.updateShowAdditCommInfo(skuItem)
      }
    },
    addToCart(sku) {
      // 加价购商品加购
      if (!this.hasAdditionRecommendList) {
        const flag = this.addList.find(item=>item.skuId===sku.skuId)
        if(!flag) {
          this.addList.push({
            skuId: sku.skuId
          })
        }
        const params = JSON.parse(JSON.stringify(this.addCartParams))
        params.additionSkuList = this.addList
        params.cartId = this.cartIdValue
        modifyCommodityApi(params)
          .then(res => {
            if (res) {
              this.$toast('加入购物车成功')
              this.disabledCartbtnIds.push(sku.spuId || sku.id)
              this.additionCartAddList.push(sku)
            }
          })
          .catch(e => {
            this.$toast(e.msg)
          })
      } else {
        // 推荐商品加购
        addCommodityApi({
          num: 1,
          mainSku: {
            skuId: sku.id
          }
        }).then(res => {
          if (res && res.code == 0) {
            this.$toast('加入购物车成功')
            this.disabledCartbtnIds.push(sku.spuId || sku.id)
            this.fetchCartNumber()
            // 更新app购物车
            app.updateCartNum({})
          }else{
            this.$toast(res.msg)
          }
        })
        .catch(e => {
          this.$toast(e.msg)
        })
      }
      this.$track({
        event_id: '081|084|01|077',
        algoInfo: sku.algoInfo,
        click_Pos: 3,
        content: sku.skuId || sku.id,
        popup_type: this.hasAdditionRecommendList ? 2 : 1,
        request_id: sku.reqId,
        score: sku.score,
        sku_id: this.skuId
      })
    },
    close() {
      this.$emit('close')
    },
    toShopingcart() {
      this.$track({
        event_id: '081|084|01|077',
        click_Pos: 2,
        popup_type: this.hasAdditionRecommendList ? 2 : 1,
        sku_id: this.skuId
      })
      app.openNewWebview({
        url: config.path.shopUrl + '/shoppingcart'
      })
    },
    stay() {
      this.$store.commit('detailv3/CHANGE_SHOP_CART_POPUP_STATUS', false)
      this.$track({
        event_id: '081|084|01|077',
        click_Pos: 1,
        popup_type: this.hasAdditionRecommendList ? 2 : 1,
        sku_id: this.skuId
      })
    },
    /**
     * @description:  添加加入购物车动画gif的DOM
     */
    addCartAniDom() {
      this.$nextTick(() => {
        const popDom = this.$refs.shopCartPopup?.$el
        const titleDom = popDom?.querySelector('.sheets-title .title')
        const dom = popDom?.querySelector('.sheets-title .title > div')
        if (dom) {
          let imgSrc = ''
          if (this.cachedAnimationBlob) {
            if (this.uniqueAnimationSrc !== undefined) {
              URL.revokeObjectURL(this.uniqueAnimationSrc)
            }
            this.uniqueAnimationSrc = URL.createObjectURL(this.cachedAnimationBlob)
            imgSrc = this.uniqueAnimationSrc
          } else {
            imgSrc = `${this.animGifUrl}?t=` + new Date().getTime()
          }
          const imgNode = document.createElement('img')
          imgNode.setAttribute('class', 'cart-gif-icon')
          imgNode.setAttribute('src', imgSrc)
          titleDom.insertBefore(imgNode, dom)
        }
      })
    },
    /**
     * @description:  移除加入购物车动画gif的DOM
     */
    removeCartAniDom() {
      try {
        const aniDom = this.$refs.shopCartPopup?.$el?.querySelector('.sheets-title .title .cart-gif-icon')
        aniDom && aniDom.remove()
      } catch (e) {}
    }
  },
  mounted() {
    // 将网络url转为blob格式，转网络缓存-本地
    axios.get(this.animGifUrl, { responseType: 'blob' }).then(res => {
      this.cachedAnimationBlob = new Blob([res.data])
    })
  }
}
</script>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
